// src/cert/iso27001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO27001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO 27001 प्रमाणन</h1>
                <p>माहिती सुरक्षा व्यवस्थापन प्रणाली (Information Security Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO 27001 म्हणजे काय?</h2>
                    <p>
                        The ISO 27001:2022 Information Security Management System Certification is essential for any organisation that aims to establish, enhance, or nurture an information security management system to conform with its established information security policy and requirements. Our international network enables us to serve organisations worldwide and certify their compliance to ISO 27001 on a global scale. Through our worldwide network of professionals, we can provide certification services no matter where you are.

                        Organisations certified to ISO 27001 demonstrate their commitment to continuous improvement and reduced Information security impact

                        As consumers are becoming increasingly aware of Information Security and data breach issues, ISO 27001 audit and certification helps your brand stand out as a responsible provider.

                        Beyond demonstrating that your organisation is committed to security, ISO 27001 certification may also reduce the risk of regulatory and Information Security liabilities.

                        ISO 27001 management system certification demonstrates your organisation,s ability to consistently meet and exceed customer expectations.
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>सायबर हल्ले, डेटा चोरी आणि गळती रोखते</li>
                        <li>कायदेशीर अनुपालन (GDPR, IT Act, RBI)</li>
                        <li>ग्राहक आणि भागीदारांचा विश्वास वाढतो</li>
                        <li>आर्थिक नुकसान आणि दंड टाळता येतात</li>
                        <li>माहिती सुरक्षा धोरणे आणि प्रक्रिया सुव्यवस्थित होतात</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO 27001 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO 27001" />
                </section>
            </div>
        </div>
    );
};

export default ISO27001;